import { render, staticRenderFns } from "./FreeGift.vue?vue&type=template&id=95f44404&scoped=true&"
import script from "./FreeGift.vue?vue&type=script&lang=js&"
export * from "./FreeGift.vue?vue&type=script&lang=js&"
import style0 from "./FreeGift.vue?vue&type=style&index=0&id=95f44404&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f44404",
  null
  
)

export default component.exports